import React from "react";
import SubscribeButton from "../../blog/components-v2/right-rail/subscribe-btn";
import ScrollEvent from '../../shared/components/scroll-event';

import { removeKebabCase, mapMultiWords } from 'hpstore-helpers';
import "../css/dlp-subscribe.less";

const urls = {
  quillImage: "https://www.hp.com/us-en/shop/app/assets/images/uploads/stage/quill%20and%20ink%2020190513%20(1)1557783074970214.png",
  subscribeLink: "https://store.hp.com/webapp/wcs/stores/servlet/ManageSubscription?catalogId=10051&langId=-1&storeId=10151&utm_source=app&utm_medium=organic&utm_campaign=email_subscribe&utm_content=dlp"
}

/*used in case a 2nd breadcrumb isn't included, the default would be to use the subcategory only*/
const getSubcategory = (categories) => (categories instanceof Array && categories.length > 0 && typeof categories[0] === 'string') ? (
  removeKebabCase({ str: categories[0].split('<<')[0], noCapital: true }).toLowerCase()
) : null;

/* if the 2nd breadcrumb (first in seo breadcrumb array, after home link) isn't there, use the subcategory text instead. */
const getCategoryText = ({ breadcrumbs, categories }) => (breadcrumbs instanceof Array && breadcrumbs.length > 0 && typeof breadcrumbs[0] === 'object' && breadcrumbs[0].text) ? (
  removeKebabCase({ str: breadcrumbs[0].text, noCapital: true }).toLowerCase()
) : getSubcategory(categories);

const dlpSubscribe = props => {
  const { keyword = "laptop", categories, breadcrumbs } = props;

  const noKebab = {
    keyword: mapMultiWords({ str: removeKebabCase({ str: keyword }) }),
    category: getCategoryText({ breadcrumbs, categories })
  };

  return (
    <div className="dlp-subscribe-block">
      <div className="dlp-subscribe-block__column dlp-subscribe-block__column--narrow">
        <img className="dlp-subscribe-block__image" src={urls.quillImage} alt="" />
      </div>
      <div className="dlp-subscribe-block__column dlp-subscribe-block__column--wide">
        <p className="dlp-subscribe-block__paragraph">
          Be the first to find out about our {noKebab.keyword}{noKebab.category ? `, latest deals on ${noKebab.category}` : ''},
          and get a special product offer just for joining us at the Official HP
          Store.
        </p>
        <SubscribeButton
          text="Subscribe"
          size="small"
          metricsElementType="modal"
          linkId="dlp-subscribe-block:subscribe"
          href={urls.subscribeLink}
        />
      </div>
    </div>
  );
};

export default dlpSubscribe;
